import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
  selector: 'app-reset-password',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.scss'
})
export class ResetPassword {
  password: string = '';
  confirmPassword: string = '';
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  error: string = '';
  isLoading: boolean = false;
  token: string = '';

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    // Récupérer le token depuis l'URL
    this.token = this.route.snapshot.queryParams['token'] || '';
  }

  onSubmit() {
    if (this.password !== this.confirmPassword) {
      this.error = 'Les mots de passe ne correspondent pas';
      return;
    }

    this.isLoading = true;
    this.error = '';

    this.authService.resetPassword({token: this.token, newPassword: this.password}).subscribe({
      next: () => {
        this.isLoading = false;
        this.notificationService.success('Votre mot de passe a été réinitialisé avec succès.');
        this.router.navigate(['/signin']);
      },
      error: (err) => {
        this.isLoading = false;
        this.error = 'Une erreur est survenue. Le lien a peut-être expiré.';
      }
    });
  }

  hasUpperCase(str: string): boolean {
    return /[A-Z]/.test(str);
  }

  hasLowerCase(str: string): boolean {
    return /[a-z]/.test(str);
  }

  hasNumber(str: string): boolean {
    return /[0-9]/.test(str);
  }

  getPasswordStrengthWidth(): string {
    const strength = this.calculatePasswordStrength();
    return `${strength * 25}%`;
  }

  getPasswordStrengthClass(): string {
    const strength = this.calculatePasswordStrength();
    if (strength === 1) return 'bg-danger';
    if (strength === 2) return 'bg-warning';
    if (strength === 3) return 'bg-info';
    return 'bg-success';
  }

  getPasswordStrengthText(): string {
    const strength = this.calculatePasswordStrength();
    if (strength === 1) return 'Faible';
    if (strength === 2) return 'Moyen';
    if (strength === 3) return 'Fort';
    return 'Très fort';
  }

  private calculatePasswordStrength(): number {
    let strength = 0;
    if (this.password.length >= 8) strength++;
    if (this.hasUpperCase(this.password)) strength++;
    if (this.hasLowerCase(this.password)) strength++;
    if (this.hasNumber(this.password)) strength++;
    return strength;
  }
}
